var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResultIconactive2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.48421 0.726778V8.36888C1.48421 8.67283 1.70132 8.88994 2.00526 8.88994H11.0368C11.3191 8.88994 11.5579 9.12875 11.5579 9.41099C11.5579 9.71494 11.3191 9.93204 11.0368 9.93204H2.00526C1.13684 9.93204 0.442105 9.2373 0.442105 8.36888V0.726778C0.442105 0.444541 0.65921 0.205725 0.963157 0.205725C1.24539 0.205725 1.48421 0.444541 1.48421 0.726778ZM10.7112 3.18007L7.73684 6.1327C7.54145 6.3498 7.21579 6.3498 7.02039 6.1327L5.30526 4.41757L3.59013 6.1327C3.37303 6.3498 3.04737 6.3498 2.85197 6.1327C2.63487 5.9373 2.63487 5.61165 2.85197 5.41625L4.93618 3.33204C5.02303 3.22349 5.15329 3.18007 5.30526 3.18007C5.43553 3.18007 5.56579 3.22349 5.67434 3.33204L7.38947 5.04717L9.97303 2.46362C10.1684 2.24651 10.4941 2.24651 10.7112 2.46362C10.9066 2.65901 10.9066 2.98467 10.7112 3.18007Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultIconactive2);
export default __webpack_public_path__ + "static/media/resultIconactive2.8a935adc93e2d0490efd81a9e6f6b19e.svg";
export { ForwardRef as ReactComponent };